import React from 'react';
import { ClockIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-terracotta text-white py-2 md:py-3 px-4 shadow-lg z-50" data-id="element-324">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center md:text-left" data-id="element-325">
        <div className="flex items-center gap-2 font-semibold text-sm md:text-base" data-id="element-326">
          <ClockIcon className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" data-id="element-327" />
          <span data-id="element-328">PRECIO DE LANZAMIENTO: $6.39</span>
        </div>
        <div className="hidden md:block w-px h-6 bg-white/30" aria-hidden="true" data-id="element-329"></div>
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-xs md:text-sm" data-id="element-330">
          <span className="flex items-center gap-1.5" data-id="element-331">
            <DownloadIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-332" />
            Descarga Inmediata
          </span>
          <span className="hidden sm:inline" data-id="element-333">•</span>
          <span className="flex items-center gap-1.5" data-id="element-334">
            <ShieldCheckIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-335" />
            Garantía de 60 Días
          </span>
        </div>
      </div>
    </div>;
}